'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _week = require('./week');

var _week2 = _interopRequireDefault(_week);

var _Time = require('@wix/wixrest-utils/dist/Time');

var _Time2 = _interopRequireDefault(_Time);

var _constants = require('../../shared/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Month = function (_React$Component) {
    _inherits(Month, _React$Component);

    function Month(props) {
        _classCallCheck(this, Month);

        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

        _this.focus = function () {
            _this.wrapper.focus();
        };

        _this.handleDayClick = function (day) {
            if (_this.props.onDayClick) {
                _this.props.onDayClick(day);
            }
        };

        _this.isWeekInMonth = function (startOfWeek) {
            var day = _this.props.day;
            var endOfWeek = startOfWeek.clone().add(6, 'days');
            return startOfWeek.isSame(day, 'month') || endOfWeek.isSame(day, 'month');
        };

        _this.renderWeeks = function () {
            var startOfMonth = _this.props.day.clone().startOf('month').startOf('week');
            return [0, 1, 2, 3, 4, 5].map(function (offset) {
                var week = startOfMonth.clone().add(offset, 'w');
                var actualOffset = week.diff(startOfMonth, 'week');

                if (actualOffset !== offset) {
                    week.add(offset - actualOffset, 'w');
                }

                return week;
            }).filter(function (startOfWeek) {
                return _this.isWeekInMonth(startOfWeek);
            }).map(function (startOfWeek, offset) {
                return _react2.default.createElement(_week2.default, { ref: function ref(el) {
                        return _this.weeks[_Time2.default.serializeDate(startOfWeek)] = el;
                    },
                    locale: _this.props.locale,
                    timezone: _this.props.timezone,
                    key: offset,
                    day: startOfWeek,
                    month: _this.props.day.month(),
                    onlyMonthDays: _this.props.onlyMonthDays,
                    onDayClick: _this.handleDayClick,
                    minDate: _this.props.minDate,
                    maxDate: _this.props.maxDate,
                    excludeDates: _this.props.excludeDates,
                    includeDates: _this.props.includeDates,
                    filterDate: _this.props.filterDate,
                    selected: _this.props.selected,
                    startDate: _this.props.startDate,
                    hovered: _this.props.hovered,
                    setHover: _this.props.setHover,
                    endDate: _this.props.endDate });
            });
        };

        _this._onKeyDown = function (e) {
            var _this$props = _this.props,
                hovered = _this$props.hovered,
                setHover = _this$props.setHover,
                onDayClick = _this$props.onDayClick,
                onTab = _this$props.onTab;

            var key = _this._getKeyPressed(e);
            var newHovered = null;
            var monthAction = null;

            if (hovered) {
                switch (key) {
                    case _constants.KEY_CODES.TAB:
                        onTab(e);
                        break;
                    case _constants.KEY_CODES.ENTER:
                        onDayClick(hovered);
                        break;
                    case _constants.KEY_CODES.LEFT:
                        newHovered = _this.getAvailableDay(hovered, -1, 'day');
                        monthAction = 'before';
                        break;
                    case _constants.KEY_CODES.RIGHT:
                        newHovered = _this.getAvailableDay(hovered, 1, 'day');
                        monthAction = 'after';
                        break;
                    case _constants.KEY_CODES.UP:
                        newHovered = _this.getAvailableDay(hovered, -1, 'week');
                        monthAction = 'before';
                        break;
                    case _constants.KEY_CODES.DOWN:
                        newHovered = _this.getAvailableDay(hovered, 1, 'week');
                        monthAction = 'after';
                        break;
                }
            }

            if (newHovered) {
                setHover(newHovered, monthAction);
                e.preventDefault();
                return false;
            }

            return true;
        };

        _this._getKeyPressed = function (event) {
            var rtl = _this.props.rtl;

            var key = event.keyCode || event.which;

            if (rtl) {
                switch (key) {
                    case _constants.KEY_CODES.LEFT:
                        key = _constants.KEY_CODES.RIGHT;
                        break;
                    case _constants.KEY_CODES.RIGHT:
                        key = _constants.KEY_CODES.LEFT;
                        break;
                }
            }

            return key;
        };

        _this.getAvailableDay = function (currentDay, direction, step) {
            var _this$props2 = _this.props,
                minDate = _this$props2.minDate,
                maxDate = _this$props2.maxDate;

            var action = direction > 0 ? 'add' : 'subtract';
            var counter = 0;
            var newDay = currentDay.clone()[action](1, step);

            if (newDay.isAfter(maxDate, 'day') || newDay.isBefore(minDate, 'day')) {
                return currentDay;
            }

            while (_this.isDayExcluded(newDay) && counter < 10) {
                if (newDay.isAfter(maxDate) || newDay.isBefore(minDate)) {
                    newDay = currentDay;
                    break;
                }
                newDay = newDay.clone()[action](1, step);
                counter += 1;
            }

            if (counter === 10) {
                newDay = currentDay;
            }

            return newDay;
        };

        _this.isDayExcluded = function (day) {
            return !!_this.props.excludeDates[_Time2.default.serializeDate(day)];
        };

        _this.weeks = {};
        _this.state = {};
        return _this;
    }

    Month.prototype.componentDidMount = function componentDidMount() {
        this.focus();
    };

    Month.prototype.render = function render() {
        var _this2 = this;

        var hovered = this.props.hovered;

        var activeDescendant = 'site-react-dropdown_' + _Time2.default.serializeDate(hovered);

        return _react2.default.createElement(
            'div',
            { className: 'wix-dropdown-datepicker__month',
                tabIndex: '0',
                onKeyDown: this._onKeyDown,
                role: 'grid',
                ref: function ref(el) {
                    return _this2.wrapper = el;
                },
                'aria-activedescendant': activeDescendant },
            this.renderWeeks()
        );
    };

    return Month;
}(_react2.default.Component);

Month.displayName = 'Month';


module.exports = Month;